export * from './customer-portal-edit.component';
